// extracted by mini-css-extract-plugin
module.exports = {"App":"Feedback__App__3nbCs","Input":"Feedback__Input__10jv5","Row":"Feedback__Row__2cGGO","Center":"Feedback__Center__36VOW","Width":"Feedback__Width__3Kj_B"};